import { format } from "date-fns";
import { getTimezoneOffset, formatInTimeZone } from "date-fns-tz";
import { GlossDateAbstraction } from "@bitwarden/web-vault/app/models/data/shared/gloss-date/gloss-date.abstraction";
import {
  dateProperties,
  timeProperties,
} from "@bitwarden/web-vault/app/models/data/shared/gloss-date/gloss-date.interface";
import {
  DateAsISOStringType,
  GlossDateAsObjectType,
} from "@bitwarden/web-vault/app/models/store/types/store.types";
import { TimeType } from "@bitwarden/web-vault/app/models/types/gloss-date.types";

export class GlossDateTime extends GlossDateAbstraction implements dateProperties, timeProperties {
  date: DateAsISOStringType;
  timeZone: string;
  offset: number;
  time: string;
  reliableTimeSource: boolean = false; // default to false

  // sets the enriched date property with the information that is available in the class
  getEnrichedDate(defaultTime?: TimeType, time?: string): Date {
    if (this.reliableTimeSource) {
      return super.getEnrichedDate(defaultTime, this.time);
    } else {
      return super.getEnrichedDate(defaultTime);
    }
  }

  setFromObject(obj: GlossDateAsObjectType, reliableTime = false): void {
    super.setFromObject(obj);
    this.time = obj.time || format(new Date(this.date), "HH:mm:ss"); // time can be null if not known
    this.reliableTimeSource = obj.reliableTimeSource || false; // default to false if not provided
  }

  setFromIsoString(
    isoDateString: DateAsISOStringType,
    timeZone: string,
    reliableTime = false,
  ): void {
    // if the timezone is provided then we need to convert the iso date string to the local timezone
    this.date = isoDateString;
    const date = new Date(isoDateString);
    this.dateString = formatInTimeZone(date, timeZone, "yyyy-MM-dd");
    this.time = formatInTimeZone(date, timeZone, "HH:mm:ss");
    this.timeZone = timeZone;
    this.offset = getTimezoneOffset(timeZone);
    this.reliableTimeSource = reliableTime; // default to false if not provided
  }

  toGlossDateAsObject(): GlossDateAsObjectType {
    return {
      date: this.date,
      timeZone: this.timeZone,
      time: this.time,
      reliableTimeSource: this.reliableTimeSource,
    };
  }
}
